<template>
  <div :class="type === 'batteryLine' ? 'wrapperBattery' : 'wrapper'">
    <div class="svgContent" :class="type">
      <svg width="240" height="150">
        <path d="M 32 140 Q 25 25 ,140 25 T 245 25" stroke-width="18" stroke="#30373C" fill="none" />
        <path
          v-if="data.status != 0"
          :class="data.status == 1 ? 'floatLinePath' : 'floatLinePathReverse'"
          d="M 32 140 Q 25 25 ,140 25 T 245 25"
          stroke-dasharray="12 8"
          stroke-width="5"
          stroke="#02DCB3"
          fill="none"
        />
      </svg>
      <div class="textContent">
        <div v-if="type !== 'batteryLine'">{{ data.val }}</div>
        <div v-else>{{ data.val[0] }}</div>
        <div v-if="data.val && data.val[1] && type === 'batteryLine'">{{ data.val[1] }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  data() {
    return {}
  },
  watch: {}
}
</script>

<style  lang="less" scoped>
.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translate(-2px, -12px);
  position: relative;
}
.wrapperBattery {
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translate(-2px, -12px);
  position: relative;
}
.textContent {
  position: absolute;
  color: #33ffb6;
  z-index: 2;
  right: 80px;
  top: 40px;
  font-size: 16px;
}
.batteryLine {
  transform: translate(-2px, -5px);
}
.generationLine {
  transform: rotateX(180deg);
  .textContent {
    transform: rotateX(180deg);
    right: 70px;
  }
}

.gridLine {
  transform: rotate(180deg);
  .textContent {
    transform: rotate(180deg);
  }
}

.consumptionLine {
  transform: rotateY(180deg);
  .textContent {
    transform: rotateY(180deg);
  }
}
.floatLinePath {
  animation: draw 4s linear infinite;
}

@keyframes draw {
  from {
    stroke-dashoffset: 500;
  }

  to {
    stroke-dashoffset: 0;
  }
}

.floatLinePathReverse {
  animation: drawReverse 4s linear infinite;
}

@keyframes drawReverse {
  from {
    stroke-dashoffset: 0;
  }

  to {
    stroke-dashoffset: 500;
  }
}
</style>